<template>
  <div
    id="nb-iot"
  >
    <!-- Map base layer — fills entire viewport behind all content -->
    <div
      class="map-layer"
      :style="{
        'top': (topOffset || 0) + 'px',
      }"
    >
      <v-skeleton-loader
        v-if="isLoading"
        type="image"
        class="map-skeleton"
      />
      <slot name="map-content" />
      <!-- Native map branding — non-interactive, embedded appearance -->
      <div class="map-brand-watermark">
        <img
          :src="nameLogo"
          alt="Reelables"
          draggable="false"
        >
      </div>
    </div>
    <div
      ref="pageContainer"
      class="page-container"
    >
      <div class="overlay-layer">
        <div
          v-if="errorMessage"
          class="error-message-container"
        >
          <ErrorMessage :error-message="errorMessage" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import NameLogoImage from '../../../assets/images/reelables-name-logo.svg';
import ErrorMessage from '../../atoms/message/error-message';
// import Loader from '../../atoms/loader/loader';
import { routeNames } from '../../../constants';

export default {
  name: 'NbIotLayout',
  components: {
    ErrorMessage,
    // Loader,
  },
  props: {
    errorMessage: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    topOffset: { type: Number, default: 0 },
  },
  data() {
    return {
      tab: 0,
      timelineHeight: 0,
      hasLoadedData: false,
    };
  },
  computed: {
    nameLogo() { return NameLogoImage; },
    // topContentIsVisible() { return this.errorMessage || this.isLoading; },
    shouldRouteToLogin() {
      return this.errorMessage === 'Not authorized to view this label';
    },
  },
  watch: {
    shouldRouteToLogin() {
      if (this.shouldRouteToLogin) {
        this.$router.replace({ name: routeNames.home });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.cdnfonts.com/css/helvetica-neue-55');
@import '@/styles/_updated-variables.scss';
@import '@/styles/_breakpoints.scss';

.map-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;

  .map-skeleton {
    width: 100%;
    height: 100%;
    ::v-deep .v-skeleton-loader__image {
      height: 100%;
    }
  }
}

.map-brand-watermark {
  position: fixed;
  bottom: 0.625rem;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  user-select: none;
  z-index: 1;

  img {
    height: 1rem;
    width: auto;
    opacity: 0.35;
    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.9))
            drop-shadow(0 0 4px rgba(255, 255, 255, 0.6));
  }

  @media (min-width: 960px) {
    bottom: 0.75rem;

    img {
      height: 1.25rem;
      opacity: 0.4;
    }
  }
}

.page-container {
  font-family: Helvetica-Neue;
  position: relative;
  z-index: 1;
  pointer-events: none;
}

.overlay-layer {
  position: relative;
  z-index: 1;
  pointer-events: auto;
}

.error-message-container {
  padding: 0.5rem;
}
</style>
<style lang="scss">
@import '@/styles/_updated-variables.scss';

#nb-iot {
  font-family: Helvetica-Neue;

  button.primary {
    color: $gray1 !important;
    caret-color: $gray1 !important;
  }

}
</style>
